import styled from 'styled-components';
import { TokenSet } from '../../styles/tokens';

export const Input = styled.input<{ tokens: TokenSet }>`
  width: 100%;
  padding: 10px 14px;
  background: ${p => p.tokens.bgElevated};
  border: 1px solid ${p => p.tokens.border};
  border-radius: 8px;
  color: ${p => p.tokens.text};
  font-size: 14px;
  transition: border-color 0.2s;

  &::placeholder {
    color: ${p => p.tokens.textFaint};
  }

  &:focus {
    border-color: ${p => p.tokens.primary};
  }
`;
